import { UserInvitationDto } from 'src/Libs/installation-rights-management/dto/user-invitations.dto'
import { UserInvitationModel } from '../models/user-invitations.model'

const userInvitationsToModelTransformer = (dtos: UserInvitationDto[]): UserInvitationModel[] => {
  return dtos
    .filter(dto => Boolean(dto.token))
    .map(dto => ({
      invitationToken: dto.token,
      installationId: dto.installationId,
      accountId: dto.accountId ?? '',
      inviteType: dto.inviteType,
      url: dto.url ?? '',
      createdAt: dto.createdAt ?? '',
      updatedAt: dto.updatedAt ?? '',
      projectName: dto.projectName ?? null,
      partnersInstallationName: dto.partnersInstallationName ?? null,
      ownerId: dto.ownerId ?? null,
      emsMasterId: dto.emsMasterId ?? -1,
      emsMasterDeviceId: dto.emsMasterDeviceId ?? '',
      emsMasterDeviceUuid: dto.emsMasterDeviceUuid ?? null,
      emsMasterDeviceShortUuid: dto.emsMasterDeviceShortUuid ?? null,
    }))
}

export default userInvitationsToModelTransformer
